'use client'

import { useState } from 'react'
import { motion } from 'framer-motion'
import { SectionHeader } from '@/components/section-header'
import { ProjectFilter } from '@/components/project-filter'
import { ProjectCard } from '@/components/project-card'
import { Container } from '@/components/container'
import { MotionDiv } from '@/components/motion-wrapper'
import { ProjectCategory, getProjectsByCategory } from '@/lib/projects-data'

export default function ProjectsPage() {
  const [activeCategory, setActiveCategory] = useState<ProjectCategory>('All')
  const filteredProjects = getProjectsByCategory(activeCategory)

  return (
    <div className="overflow-hidden">
      <Container className="py-12 sm:py-16 md:py-24">
        <MotionDiv
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <SectionHeader
            subheading="Case Studies"
            heading="Our Work"
            description="Real projects showcasing how we've helped startups and enterprises transform ideas into scalable products. Each case study includes the challenge, our solution, and the impact."
          />
        </MotionDiv>

        <div className="mt-12">
          <ProjectFilter
            activeCategory={activeCategory}
            onCategoryChange={setActiveCategory}
          />
        </div>

        <motion.div
          key={activeCategory}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProjects.map((project, index) => (
              <ProjectCard key={project.slug} project={project} index={index} />
            ))}
          </div>
        </motion.div>

        {filteredProjects.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600">No projects found in this category.</p>
          </div>
        )}
      </Container>
    </div>
  )
}
